import type { TourSpec } from "./types";

export const tsmTour: TourSpec = {
  id: "tsm",
  version: 1,
  buildSteps: (t) => [
    {
      target: '[data-tour="tsm-filter-sidebar"]',
      title: t("tsm.filters.title"),
      content: t("tsm.filters.body"),
      placement: "right",
      skipBeacon: true,
    },
    {
      target: '[data-tour="tsm-data-table"]',
      title: t("tsm.table.title"),
      content: t("tsm.table.body"),
      placement: "top",
    },
    {
      target: '[data-tour="tsm-pagination"]',
      title: t("tsm.pagination.title"),
      content: t("tsm.pagination.body"),
      placement: "top",
    },
  ],
};
